import { render, staticRenderFns } from "./SalidasForm.vue?vue&type=template&id=6f2978e6&"
import script from "./SalidasForm.vue?vue&type=script&lang=js&"
export * from "./SalidasForm.vue?vue&type=script&lang=js&"
import style0 from "./SalidasForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports